import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useMatch } from 'react-router-dom';
import { VisDisplayModeSwitcher } from '@/components/visualisations/VisDisplayModeSwitcher';
import { useVisDisplayMode } from '@/hooks/useVisDisplayMode';
import { VisDisplayMode } from '@/types/visualisation';
import { EditColumnsButton } from '../button/EditColumnsButton';
import { ExportCsvMenuItem } from '../export/ExportCsvMenuItem';
import { MoreOptionsMenu } from '../menu/MoreOptionsMenu/MoreOptionsMenu';
import { SectionControlsWrapper } from './SectionControlsWrapper';
import { VisControls } from './VisControls';

export const EventDataControls = ({
  metricKeyDropdownComponent,
  defaultDisplayMode,
}: {
  metricKeyDropdownComponent?: ReactNode;
  defaultDisplayMode?: VisDisplayMode;
}) => {
  const isEventDataLocker = !!useMatch('/:locale/data-locker/events/*');
  const { t } = useTranslation(['navigation', 'visualisation']);
  const [visDisplayMode] = useVisDisplayMode();
  const heading = isEventDataLocker
    ? t('crossPlatform.secondary.events', { ns: 'navigation' })
    : t('displayVis', { ns: 'visualisation' });

  return (
    <SectionControlsWrapper heading={heading} headerComponent={visDisplayMode === 'vis' && metricKeyDropdownComponent}>
      {visDisplayMode === 'table' && <EditColumnsButton />}

      <VisDisplayModeSwitcher defaultDisplayMode={defaultDisplayMode} />

      {visDisplayMode === 'table' && (
        <MoreOptionsMenu>
          <ExportCsvMenuItem />
        </MoreOptionsMenu>
      )}

      {visDisplayMode === 'vis' && <VisControls />}
    </SectionControlsWrapper>
  );
};
